import { render, staticRenderFns } from "./bid_check_config_detail.vue?vue&type=template&id=3e5b75fd&scoped=true"
import script from "./bid_check_config_detail.vue?vue&type=script&lang=js"
export * from "./bid_check_config_detail.vue?vue&type=script&lang=js"
import style0 from "./bid_check_config_detail.vue?vue&type=style&index=0&id=3e5b75fd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5b75fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e5b75fd')) {
      api.createRecord('3e5b75fd', component.options)
    } else {
      api.reload('3e5b75fd', component.options)
    }
    module.hot.accept("./bid_check_config_detail.vue?vue&type=template&id=3e5b75fd&scoped=true", function () {
      api.rerender('3e5b75fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/customform/bid_check_config_detail.vue"
export default component.exports